import React from 'react';

const UI = {
  spacing: { xs: 6, sm: 8, md: 12, lg: 16, xl: 24 },
  radius: { sm: 6, md: 8, lg: 12 },
  colors: {
    primary: "#0F172A",
    secondary: "#334155",
    muted: "#64748B",
    border: "#E2E8F0",
    bg: "#F8FAFC",
    success: "#059669",
    warning: "#D97706",
    danger: "#DC2626",
    info: "#3B82F6"
  }
};

const KpiStrip = ({ cards, activeKey, onCardClick }) => {
  return (
    <div style={{
      display: 'flex',
      gap: UI.spacing.md,
      overflowX: 'auto',
      paddingBottom: UI.spacing.sm,
      marginBottom: UI.spacing.xl
    }}>
      {cards.map((card, idx) => {
        const isActive = activeKey === card.key;
        const deltaValue = card.delta || 0;
        const isPositive = deltaValue >= 0;
        
        return (
          <div
            key={idx}
            onClick={() => onCardClick?.(card.key)}
            style={{
              minWidth: 160,
              background: isActive ? UI.colors.primary : UI.colors.white,
              border: isActive ? 'none' : `1px solid ${UI.colors.border}`,
              borderRadius: UI.radius.lg,
              padding: `${UI.spacing.md}px ${UI.spacing.lg}px`,
              cursor: 'pointer',
              transition: 'all 0.15s ease'
            }}
            onMouseEnter={(e) => {
              if (!isActive) {
                e.currentTarget.style.transform = 'translateY(-2px)';
                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0,0,0,0.1)';
              }
            }}
            onMouseLeave={(e) => {
              if (!isActive) {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'none';
              }
            }}
          >
            <div style={{
              fontFamily: "'Playfair Display', serif",
              fontSize: 24,
              fontWeight: 800,
              color: isActive ? UI.colors.white : UI.colors.primary,
              marginBottom: UI.spacing.xs
            }}>
              {card.value}
            </div>
            <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontSize: 12,
              fontWeight: 600,
              color: isActive ? 'rgba(255,255,255,0.8)' : UI.colors.muted,
              marginBottom: UI.spacing.sm
            }}>
              {card.label}
            </div>
            {card.delta !== undefined && (
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                fontFamily: "'Plus Jakarta Sans', sans-serif",
                fontSize: 11,
                fontWeight: 600,
                color: isActive 
                  ? (isPositive ? '#86EFAC' : '#FCA5A5')
                  : (isPositive ? UI.colors.success : UI.colors.danger)
              }}>
                <span>{isPositive ? '↑' : '↓'}</span>
                <span>{Math.abs(deltaValue)}%</span>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default KpiStrip;